 
<div class="max-page-width">
  <div class="google-map-contactUs">
    <agm-map [latitude]="lat" [longitude]="lng">
      <agm-marker [latitude]="agency.latitude" [longitude]="agency.longitude" *ngFor="let agency of agencies"></agm-marker>

    </agm-map>
  </div>

  <div class="inner-page">
    <h2 class="mb-0">{{ 'Branches' | translate }}</h2>
    <div class="row">
      <div class="col-md-4" *ngFor="let Branch of agencies">
        <div class="contact-us">
          <p>{{Branch.companyName}}</p>
          <ul>
            <li>{{Branch.address}}</li>
            <li>{{Branch.phoneNo}}</li>
            <li>{{Branch.email}}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <div class="view-only-bg-grey mt-4">
    <div class="inner-page">

      <div class="confirm-contact" *ngIf="showConfirm">
        <i class="fas fa-check-circle mr-2 fa-1x"></i> {{ 'Great!YourInquiryhasbeensentsuccessfully,Ourteamwillgetbacktoyousoon' | translate }}.
      </div>


      <h2>{{ 'ContactUs' | translate }}</h2>
      <form  name="form" [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="row">
          <div class="col-md-5">
            <div class="form-group">
              <label for="firstName">{{ 'Name' | translate }}</label>
              <input placeholder="{{ 'Name' | translate }}" type="text" class="form-control" formControlName="name" [ngClass]="{'is-invalid':subbmited && form.get('name').invalid}" required />

              <mat-error *ngIf=" subbmited && form.controls['name'].errors?.required"><div class="error-msg">
                <div class="validation-error"><i class="far fa-times-circle mr-1"></i>{{ 'ThisFiledIsRequired' | translate }}</div>
              </div></mat-error>
            </div>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-5"></div>
        </div>

        <div class="row">
          <div class="col-md-5">
            <div class="form-group">
              <label for="email">{{ 'Email' | translate }}</label>
              <input placeholder="{{ 'Email' | translate }}" type="text" class="form-control" formControlName="email" [ngClass]="{'is-invalid': subbmited && form.get('email').invalid}"   />
              <!-- <div *ngIf="subbmited && form.get('email').invalid"  class="invalid-feedback">
                <div *ngIf="form.get('email').errors.required"><div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}</div></div>
                <div *ngIf="form.get('email').errors.email"><div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'InvalidEmailAddress' | translate }}</div></div>
              </div> -->
              <div *ngIf="subbmited && form.get('email').invalid"  class="invalid-feedback">
                <div *ngIf="form.get('email').errors.pattern"><i class="far fa-times-circle mr-1"></i>{{ 'InvalidEmailAddress' | translate }}</div>
                <div *ngIf="form.get('email').errors.required"><i class="far fa-times-circle mr-1"></i>{{ 'ThisFiledIsRequired' | translate }}</div>
              </div>
            </div>
          </div>
          <div class="col-md-1"></div>
          <div class="col-md-5">
            <div class="form-group">
              <label for="lastName">{{ 'MobileNumber' | translate }}</label>
              <ngx-intl-tel-input [cssClass]="'form-control border-0'" [preferredCountries]="preferredCountries"
              [enableAutoCountrySelect]="true" [enablePlaceholder]="true" [searchCountryFlag]="true"
              [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]" [selectFirstCountry]="false"
              [selectedCountryISO]="selectedCountryISO" [maxLength]="15" 
              [phoneValidation]="true" [separateDialCode]="separateDialCode"
              (countryChange)="mobileNumCountryCodeChanged()"
              (keydown.space)="$event.preventDefault();"
              [ngClass]="{'is-invalid':subbmited && form.get('mobileNumber').invalid}"
              name="mobileNumber"
              formControlName="mobileNumber">
              </ngx-intl-tel-input>
              <div *ngIf="form.get('mobileNumber').errors!=null" class="invalid-feedback">
                <div *ngIf="form.get('mobileNumber').errors.required">
                  <div class="validation-error">
                    <fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}
                  </div>
                </div>
                <div *ngIf="form.get('mobileNumber').errors.validatePhoneNumber!=null">
                  <div class="validation-error">
                    <fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'Invalidphonenumber' | translate }}
                  </div>
                </div>
                <div *ngIf="form.get('mobileNumber').errors.RequiredCountryCode!=null">
                  <div class="validation-error">
                    <fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'RequiredCountryCode' | translate }}
                  </div>
                </div>
                <div *ngIf="form.get('mobileNumber').errors.InvalidSpace!=null">
                  <div class="validation-error">
                    <fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'InvalidSpace' | translate }}
                  </div>
                </div>
              </div>
             
              <!-- <input placeholder="{{ 'MobileNumber' | translate }}" type="text" class="form-control" formControlName="mobileNumber" [ngClass]="{'is-invalid':subbmited && form.get('mobileNumber').invalid}" required />
              <div class="invalid-feedback">
                <div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}</div>
              </div> -->
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-11">
            <div class="form-group">
              <label for="lastName">{{ 'Context' | translate }}</label>
              <textarea placeholder="{{ 'Context' | translate }}" rows="4" type="text" class="form-control" formControlName="message" [ngClass]="{'is-invalid':subbmited && form.get('message').invalid}" required >
                </textarea>
              <div class="invalid-feedback">
                <div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}</div>
              </div>
            </div>
          </div>
        </div>


        <div class="form-group mt-3">
          <button  class="btn default-btn mr-3" mat-button>{{ 'Submit' | translate }}</button>
          <button type="reset" class="btn default-cancel-btn" mat-button>{{ 'Cancel' | translate }}</button>
        </div>
      </form>

    

    </div>
  </div>
</div>